import { License } from '@navfleet/client/license/domain/models';
import { NAV_ROUTES, NavRoute } from '@navfleet/client/navigation/domain/models';
import { Permission } from '@navfleet/client/permission/domain/models';
import { SideMenuItem } from './layout.model';

export enum UserStartPage {
    FleetStatus = 'fleet-status',
    FleetMap = 'fleet-map',
    FleetEvents = 'fleet-events',
    VesselList = 'vessel-list',
    EmissionsOverview = 'emissions-overview',
}

export const USER_START_PAGE_ROUTES: { [key in UserStartPage]: NavRoute } = {
    [UserStartPage.FleetStatus]: NAV_ROUTES.FLEET.children.OVERVIEW,
    [UserStartPage.FleetMap]: NAV_ROUTES.FLEET.children.MAP,
    [UserStartPage.FleetEvents]: NAV_ROUTES.FLEET.children.EVENTS,
    [UserStartPage.VesselList]: NAV_ROUTES.VESSEL,
    [UserStartPage.EmissionsOverview]: NAV_ROUTES.EMISSIONS.children.OVERVIEW,
};

export const SIDEMENU_ITEMS: SideMenuItem[] = [
    {
        route: NAV_ROUTES.FLEET,
        icon: 'pi-fl-fleet',
        dataQa: 'fleet',
    },
    {
        route: NAV_ROUTES.VESSEL,
        icon: 'pi-fl-vessels',
        dataQa: 'vessel',
    },
    {
        route: NAV_ROUTES.PASSAGES,
        icon: 'pi-fl-passages',
        dataQa: 'passages',
    },
    {
        route: NAV_ROUTES.PORTS,
        icon: 'pi-fl-anchor-menu',
        dataQa: 'ports',
    },
    {
        route: {
            title: 'SIDEMENU.VESSEL_REPORTING',
            path: 'https://performance.navtor.com/#!/site/kpi',
            licenses: {
                oneRequired: [License.LinkToTVA, License.LinkToReporting],
            },
            permissions: {
                allRequired: [Permission.EmissionLinks],
            },
        },
        icon: 'pi-fl-reporting',
        dataQa: 'vessel-reporting',
    },
    {
        route: NAV_ROUTES.DOCUMENTS,
        icon: 'pi-fl-documents',
        dataQa: 'documents',
    },
    {
        route: NAV_ROUTES.LOGBOOK_ANALYTICS,
        icon: 'pi-fl-documents',
        dataQa: 'logbook-analytics',
    },
    {
        route: {
            title: 'SIDEMENU.VESSEL_ANALYTICS',
            path: 'https://performance.navtor.com/#!/analytics/dashboard',
            licenses: {
                oneRequired: [License.LinkToTVA, License.LinkToAnalytics],
            },
            permissions: {
                allRequired: [Permission.EmissionLinks],
            },
        },
        icon: 'pi-fl-analytics',
        dataQa: 'vessel-analytics',
    },
    {
        route: NAV_ROUTES.EMISSIONS,
        icon: 'pi-fl-emissions',
        dataQa: 'emissions',
    },
    {
        route: NAV_ROUTES.PORT_STATE_CONTROL,
        icon: 'pi-fl-port-state-control',
        dataQa: 'port-state-control',
    },
    {
        route: NAV_ROUTES.TIERS,
        icon: 'pi-fl-tiers',
        marginTop: true,
        dataQa: 'tiers',
    },
    {
        route: NAV_ROUTES.DISCOVER,
        icon: 'pi-fl-discover',
        dataQa: 'discover',
    },
    {
        route: NAV_ROUTES.SETTINGS,
        icon: 'pi-fl-settings',
        dataQa: 'settings',
    },
];
